<template>
    <div class="signDialog" v-loading="loading">
        <data-info-form ref="signInForm"></data-info-form>
        <data-info-table :dictData="dictData" ref="signInTable"></data-info-table>
    </div>
</template>
<script>
import { dictWithUrl } from '@/components/lots/api.js';
import DataInfoForm from './DataInfoForm.vue';
import DataInfoTable from './DataInfoTable.vue';
export default {
    name: 'WarehouseData',
    components: {
        DataInfoForm,
        DataInfoTable
    },
    props: {
        dataInfo: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data() {
        return {
            loading: false,
            dictData: {} // 字典数据
        };
    },
    mounted() {
        this.initWarehouseData();
    },
    methods: {
        async initWarehouseData() {
            this.loading = true;
            await this.getDictData();
            this.$refs.signInForm.initFormData(this.dataInfo);
            this.$refs.signInTable.initTableData(this.dataInfo.commodityDetail || []);
            this.loading = false;
        },
        /**
         * @description 获取数据字典
         * O_ITEM_STATUS: 商品状态
         */
        getDictData () {
            return dictWithUrl('O_ITEM_STATUS').then(res => {
                if (res && +res.code === 0) {
                    this.dictData = res.data || {};
                }
            });
        }
    }
};
</script>